<template>
  <section>
    <div class='wrapper'>
      <div class='loading'>
            <span
              :style='{
                width: "20px",
                animationDuration: duration.indexOf("s") === -1 ? duration + "s" : duration ,
                animationDelay: parseInt(duration)/text.length*index +"s"
              }'
              v-for='(char,index) in text' :key="index">
              {{char}}
            </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    duration: {
      type: String,
      default: '1s'
    }
  },
  data () {
    return {
      msg: ''
    }
  },
  methods: {},
  mounted: function () {
  }
}
</script>

<style scoped>
.wrapper{
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: rgba(256, 256, 256, 1);
  z-index: 9999;
}
.loading {
  display: flex;
  text-align: center;
  padding-top: 300px;
  height: 50px;
  justify-content: space-between;
}
.loading span {
  margin-top: 0;
  animation: ease infinite move;
  display: block;
  color: black;
}

@keyframes move {
  0% {
    margin-top: -10px;
    border-bottom: 1px solid;
  }
  50% {
    margin-top: 10px;
    border-bottom: none;
  }
  100% {
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/loading.vue